export default __webpack_public_path__ + "static/media/twitter.8bbf9284.svg";